// global
import React from 'react';
import PropTypes from 'prop-types';
// components
import { Popup } from 'semantic-ui-react';
import DefaultButton from './DefaultButton';
//stylesheet
import { COLORS } from 'app/config/colors';
import check from '../../../../assets/icons/popup-button-check.svg';
import x from '../../../../assets/icons/popup-button-x.svg';

function ChangeStatusButton(props) {
  const { entity, onChangeStatus, disabled, tag } = props;

  // const statusActive = ['ACTIVE', 'active', 1];

  // let isActive =
  //   typeof entity.status === 'object'
  //     ? statusActive.includes(entity.status.name)
  //     : statusActive.includes(entity.status);

  const statusActive = new Set(['ACTIVE', 'active', 1]);

  let isActive = false;

  if (entity.status !== null) {
    if (typeof entity.status === 'object') {
      isActive = statusActive.has(entity.status.name);
    } else {
      isActive = statusActive.has(entity.status);
    }
  }

  const iconName = isActive ? x : check;

  return (
    <Popup
      trigger={
        <DefaultButton
          tag=''
          color={COLORS.ACCENTUATED_VARIANT}
          colorHover={COLORS.WHITE_VARIANT}
          backgroundColor={COLORS.WHITE_VARIANT}
          backgroundColorHover={COLORS.WHITE_VARIANT}
          borderColor={COLORS.SECONDARY_VARIANT}
          borderColorHover={COLORS.SECONDARY_VARIANT}
          onClick={onChangeStatus(entity)}
          icon={iconName}
          iconHover={iconName}
          size='medium'
          disabled={disabled}
        />
      }
      content={tag}
      position='top center'
      positionFixed
      inverted
    />
  );
}

ChangeStatusButton.defaultProps = {
  tag: 'Desativar'
};

ChangeStatusButton.propTypes = {
  entity: PropTypes.object,
  onChangeStatus: PropTypes.func,
  isForm: PropTypes.bool,
  isPadCreatorStyle: PropTypes.bool,
  disabled: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default ChangeStatusButton;
